win     = window
$win    = $(win)
dirName = window.dirName
conf    =
    breakPoint : window[dirName+'Param'].breakPoint
    view       : null
window.examConf = conf

# ==============================================================================
# リサイズイベント
# ==============================================================================
resizeListener = {}
$win.on('resize', (()->
    timer = null
    dist  = 250
    first = true
    resizeHandler = ()->
        conf.w    = $win.width()
        conf.h    = $win.height()
        conf.view = if conf.breakPoint <= conf.w then 'large' else 'small'
        if !first
            for key of resizeListener then resizeListener[key](conf)
        else
            first = false
        return
    resizeHandler()
    # --------------------------------------------------------------------------
    return ()->
        if timer then clearTimeout(timer)
        timer = setTimeout(resizeHandler, dist)
        return
)())
window.examResizeListener = resizeListener


# ==============================================================================
# ドロワー操作
# ==============================================================================
do->
    $btn  = $('.drower-btn a')
    $body = $('body')
    view  = null
    $btn.on('click', (e)->
        view = 'small'
        e.preventDefault()
        if $body.hasClass('drower-active')
            $body.removeClass('drower-active')
        else
            $body.addClass('drower-active')
        return
    )
    # 小さい画面から大きい画面に移動するときはリセットする
    resizeListener.drower = (conf)->
        if conf.view != view && conf.view is 'large'
            view = conf.view
            $body.removeClass('drower-active')
        return
    return
